/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramTransactionsUserControllerGetPartsForAmountMutationRequest,
  TelegramTransactionsUserControllerGetPartsForAmountMutationResponse,
  TelegramTransactionsUserControllerGetPartsForAmount400,
  TelegramTransactionsUserControllerGetPartsForAmount401,
  TelegramTransactionsUserControllerGetPartsForAmount404,
} from '../types/TelegramTransactionsUserControllerGetPartsForAmount.ts';

function getTelegramTransactionsUserGetPartsForAmountUrl() {
  const res = { method: 'POST', url: `/api/user/telegram/transactions/parts-by-amount` as const };
  return res;
}

/**
 * {@link /api/user/telegram/transactions/parts-by-amount}
 */
export async function telegramTransactionsUserGetPartsForAmount(
  data?: TelegramTransactionsUserControllerGetPartsForAmountMutationRequest,
  config: Partial<RequestConfig<TelegramTransactionsUserControllerGetPartsForAmountMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramTransactionsUserControllerGetPartsForAmountMutationResponse,
    ResponseErrorConfig<
      | TelegramTransactionsUserControllerGetPartsForAmount400
      | TelegramTransactionsUserControllerGetPartsForAmount401
      | TelegramTransactionsUserControllerGetPartsForAmount404
    >,
    TelegramTransactionsUserControllerGetPartsForAmountMutationRequest
  >({
    method: 'POST',
    url: getTelegramTransactionsUserGetPartsForAmountUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
